import React, { useMemo } from 'react';
import classes from './AudienceFilter.module.scss';
import { useAudiencesLists } from '../../../../Audiences/hooks/hooks';
import { AppTableFilter } from '../../../../AppTable/model';

export const AudienceFilter = ({ filter }: { filter: AppTableFilter }) => {
    const label = filter?.label;

    const { audiencesList } = useAudiencesLists();

    const audience = useMemo(() => audiencesList?.find?.(audience => audience.id == filter?.value), [audiencesList, filter?.value]);

    return label ? (
        <div className={classes.audienceFilter}>
            <div className={classes.label}>
                <div className={classes.labelText}>{label}</div>

                {typeof audience?.size === 'number' && <div className={classes.labelNumber}>{audience?.size}</div>}
            </div>
        </div>
    ) : null;
};
